export default __webpack_public_path__ + "static/media/post_campaign-banner-mobile.9f095c11.jpg";